import storage from 'store'
import {
	base64Encode
} from '@/utils/crypto'
import {
	ACCESS_TOKEN,
	LAST_OPER_TIME,
	LOGIN_USER_STATE
} from '@/store/mutation-types'
import {
	loginForPassword,
	getUserInfo
} from '@/api/user'
const user = {
	state: {
		token: '',
		userId: '',
		userName: '',
		welcome: '',
		avatar: '',
		depts: [],
		roles: [],
		config: {},
		info: {}
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_USER_ID: (state, userId) => {
			state.userId = userId
		},
		SET_USER_NAME: (state, userName) => {
			state.userName = userName
		},
		SET_DEPTS: (state, depts) => {
			state.depts = depts
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_CONFIG: (state, config) => {
			state.config = config
		},
		SET_INFO: (state, info) => {
			state.info = info
		}
	},
	actions: {
		LoginForPassword({
			commit
		}, data) {
			return new Promise((resolve, reject) => {
				loginForPassword(data).then(res => {
					if (res.code == 0) {
						commit('SET_TOKEN', base64Encode(res.data.access_token))
						storage.set(ACCESS_TOKEN, base64Encode(res.data.access_token))
						storage.set(LAST_OPER_TIME, new Date().getTime())
						resolve()
					} else {
						reject(res)
					}

				}).catch(error => {
					reject(error)
				})
			})
		},
		// LoginForSmsCode ({ commit }, data) {
		//   return new Promise((resolve, reject) => {
		//       loginForSmsCode(data).then(res => {
		//         const result = res.result
		//         commit('SET_TOKEN', base64Encode(result.access_token))
		//         storage.set(ACCESS_TOKEN, base64Encode(result.access_token))
		//         storage.set(LAST_OPER_TIME, new Date().getTime())
		//         resolve()
		//       }).catch(error => {
		//         reject(error)
		//       })
		//   })
		// },
		GetUserInfo({
			commit
		}) {
			return new Promise((resolve, reject) => {
				getUserInfo().then(res => {
					const result = res.data
					// commit('SET_CONFIG', result.userConfig)
					// commit('SET_DEPTS', result.userDepts)
					// commit('SET_ROLES', result.userRoles)
					commit('SET_INFO', result)
					// commit('SET_USER_NAME', result.userBase.nickName)
					// commit('SET_USER_ID', result.userBase.userId)
					storage.set(LOGIN_USER_STATE, {
						isLogin: true,
						userInfo: base64Encode(JSON.stringify(result))
					})
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getCookie(name) {
			const cookies = document.cookie.split("; ")
			for (let i = 0; i < cookies.length; i++) {
				const cookie = cookies[i].split("=")
				if (cookie[0] === name) {
					return cookie[1]
				}
			}
			return ""
		},
		Logout() {
			return new Promise((resolve) => {
				// var r = this.getCookie("TOKEN")
				// var t = new Date;
				// t.setTime(t.getTime() - 1);
				document.cookie = "TOKEN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=.lwkjfhq.com";
				storage.remove(LOGIN_USER_STATE);
				resolve()	
			})
		},
	}
}

export default user